import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Box } from "@material-ui/core";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { CredentialPicker } from "../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Connect({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DATABASE.CONNECT.";
  const [databaseType, setDatabaseType] = useState(
    !action.fields?.databaseType?.value && "mssql"
  );
  const [value, setValue] = useState("tns");
  const [radioButtonValue, setRadioButtonValue] = useState("sname");

  useEffect(() => {
    if (!action.fields.instanceType) {
      action.fields.instanceType = { value: "" };
    } else {
      if (action.fields.instanceType.value.length > 1) setValue(action.fields.instanceType.value);
      if (action.fields.instanceType.value === "direct") {
        if (action.fields.serviceName) {
          setRadioButtonValue("sname");
        } else {
          setRadioButtonValue("sid");
        }
      }
    }
    if (!action.fields.databaseType || action.fields.databaseType?.value === '') {
      action.fields.databaseType = { value: "mssql" };
    } else {
      if (action.fields.databaseType.value.length > 1) {
        setDatabaseType(action.fields.databaseType.value);
      }
    }
  }, [action]);

  const handleSelect = (event) => {
    if (event.target.value === "mysql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.instanceName;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "mssql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.port;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "postgresql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.port;
        delete action.fields.instanceName;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "oracle") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
    }
  };

  // changed tabs panel
  const handleChange = (newValue) => {
    if (newValue === "tns" && action.fields) {
      delete action.fields.systemId;
      delete action.fields.serviceName;
    } else if (newValue === "direct" && action.fields) {
      delete action.fields.tns;
    }
    if (!action.fields.instanceType) {
      action.fields.instanceType = { value: newValue };
    } else {
      action.fields.instanceType.value = newValue;
    }
    setValue(newValue);
  };

  const handleRadioCheck = (event) => {
    if (event.target.value === "sid" && action.fields) {
      delete action.fields.serviceName;
    } else if (event.target.value === "sname" && action.fields) {
      delete action.fields.systemId;
    }
    setRadioButtonValue(event.target.value);
  };

  return (
    <div>
      <div className="form-element">
        {t(label + "DATABASE-TYPE")}
        <Select
          value={databaseType}
          onChange={(e) => handleSelect(e)}
          variant="outlined"
          fullWidth
          style={{ width: "90%" }}
        >
          <MenuItem value="mssql">Microsoft SQL Server</MenuItem>
          <MenuItem value="mysql">MySQL</MenuItem>
          <MenuItem value="postgresql">PostgreSQL</MenuItem>
          <MenuItem value="oracle">Oracle</MenuItem>
        </Select>
      </div>
      <div className="form-element">
        {t(label + "SERVER-NAME")}
        <TextInput
          action={action}
          inputName="serverName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
        />
      </div>
      {databaseType !== "oracle" && (
        <div className="form-element">
          {t(label + "DATABASE-NAME")}
          <TextInput
            action={action}
            inputName="databaseName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired
          />
        </div>
      )}
      <div className="form-element">
        {t(label + "USER")}
        <CredentialPicker
          action={action}
          inputName="loginUser"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        {t(label + "PASSWORD")}
        <CredentialPicker
          action={action}
          inputName="loginPassword"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          isPassword={true}
        />
      </div>
      {(databaseType === "mysql" || databaseType === "oracle" || databaseType === "mssql") && (
        <div className="form-element">
          {t(label + "PORT")}
          <TextInput
            action={action}
            inputName="port"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={databaseType === "mssql" ? false : true}
          />
        </div>
      )}
      {databaseType === "mssql" && (
        <div className="form-element">
          {t(label + "INSTANCE-NAME")}
          <TextInput
            action={action}
            inputName="instanceName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
          />
        </div>
      )}
      {databaseType === "oracle" && (
        <div className="form-element">
          Oracle {t(label + "INSTANCE-NAME")}
          <div className="condition-tabs">
            <button
              className={value === "tns" ? "condition-active" : ""}
              onClick={() => handleChange("tns")}
            >
              {t(label + "TNS")}
            </button>
            <button
              className={value === "direct" ? "condition-active" : ""}
              onClick={() => handleChange("direct")}
            >
              {t(label + "DIRECT")}
            </button>
          </div>
          <TabPanel value={value} index="tns">
            <TextInput
              action={action}
              isRequired={false}
              inputName="tns"
              variables={variables}
              setOpenVariable={setOpenVariable}
            />
          </TabPanel>
          <TabPanel value={value} index="direct">
            <div className="form-element">
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="gender"
                  name="direct"
                  value={radioButtonValue}
                  onChange={handleRadioCheck}
                >
                  <FormControlLabel
                    value="sname"
                    control={<Radio color="default" />}
                    label={t(label + "SERVICE-NAME")}
                  />
                  <FormControlLabel
                    value="sid"
                    control={<Radio color="default" />}
                    label={t(label + "SYSTEM-ID")}
                  />
                </RadioGroup>
              </FormControl>
              <TextInput
                action={action}
                inputName={
                  radioButtonValue === "sid" ? "systemId" : "serviceName"
                }
                variables={variables}
                setOpenVariable={setOpenVariable}
                isRequired={false}
              />
            </div>
          </TabPanel>
        </div>
      )}
    </div>
  );
}

export default Connect;